import { useEffect, useState } from 'react';
import { CoachSeats } from '../interfaces/coachSeats';
import { entityGeneralSetupService } from '../services/entityGeneralSetupService';

export const useCoachSeats = (entityId: number) => {
  const [coachSeats, setCoachSeats] = useState<CoachSeats>();

  const getCoachSeats = async () => {
    const response = await entityGeneralSetupService.getCoachSeats(entityId);
    setCoachSeats(response);
  };

  useEffect(() => {
    getCoachSeats();
  }, []);

  return { coachSeats };
};
